
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import "@arco-design/web-react/dist/css/arco.css";
import { Layout, Menu, Space, PageHeader, Carousel, Modal,Input, Trigger  } from '@arco-design/web-react';

import * as utils from '../utils'
import { IconMenu, IconSearch } from '@arco-design/web-react/icon';
import { Button } from 'react-bootstrap';
import MyComp from '../comp/my-comp.js';
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
const InputSearch = Input.Search;

class NAVBAR extends MyComp{
  constructor(props) {
    super(props);
    this.state = {
      selectKey:'0',
      showSearch: false,

      winWidth: 0,
      winHeight: 100,
    }
  }

  // componentDidMount(){
  // }
  getSearchDetailButton(){
    return (
      <InputSearch allowClear placeholder='Enter keyword to search' style={{ width: 350 }}/>
    )
  }
  getSearchButton(){
    let {showSearch} = this.state
    return (<MenuItem key='search'><IconSearch /></MenuItem>)
    return (<IconSearch />)
    // if(showSearch){
    //   return (
    //     <InputSearch allowClear placeholder='Enter keyword to search' style={{ width: 350 }} />
    //   )
    // }
    return (

        <Trigger
          popup={()=>this.getSearchDetailButton()}
          trigger={['click', 'hover']}
          clickToClose
          position='top'
          onVisibleChange={(v) => {
            this.setState({
              showSearch: !showSearch
            })
          }}
        >
          <div className={`button-trigger ${showSearch ? 'button-trigger-active' : ''}`}>
          <IconSearch />
          </div>
        </Trigger>
    )
  }
  getMoreButton(){
    return (<MenuItem key='more'><IconMenu /></MenuItem>)
    return (<IconMenu />)
    return (
      // <MenuItem key='more' selectable={false}><IconMenu /></MenuItem>
      
      <SubMenu key='more' title={<IconMenu />}>
        <MenuItem key='more_1'>更多1</MenuItem>
        <MenuItem key='more_2'>更多2</MenuItem>
      </SubMenu>
    )
  }
  getMoreShortButton(){
    return (<IconMenu onClick={()=>{
      this.setState({showModal: true})
    }}/>)
  }
  getMenuButton(dat){
    return <MenuItem key={dat.url}>{dat.title}</MenuItem>
    return (
      <SubMenu key={dat.url} title={dat.title} selectable>
        <MenuItem key={dat.url+"?a=1"}>{dat.title+'子1'}</MenuItem>
        <MenuItem key={dat.url+"?a=2"}>{dat.title+'子2'}</MenuItem>
      </SubMenu>
    )
  }
  getEnButton(){
    let {language} = this.props
    let title = '简体中文'
    if(language == 'ch'){

    }else if(language == 'en'){
      title = 'English'
    }else if(language == 'de'){
      title = 'Deutsch'
    }
    return (
      <SubMenu key='menu' title={title}>
        <MenuItem key='menu_1'>简体中文</MenuItem>
        <MenuItem key='menu_2'>English</MenuItem>
        <MenuItem key='menu_3'>Deutsch</MenuItem>
      </SubMenu>
    )
  }

  getLogoWidth(){
    let {language} = this.props
    if(language == 'ch'){
      return 120
    }
    return 179
  }

  getHeadImg(){
    let {language} = this.props
    let srcPath = '../logo.png'
    if(language == 'en' || language == 'de'){
      srcPath = '../logo_en.png'
    }
    let logoWidth = this.getLogoWidth()
    return (
      <img src={srcPath} style={{width:logoWidth,height:30}}
        onClick={()=>{
          this.props.history.push({
            pathname:'/index',
            state: []
          })
        }}
      ></img>
    )
  }

  getModalMenu(){
    let {language} = this.props
    console.log(language)

    let menuList = utils.GetMenuList(language)
    let selectKey = ''
    if(this.props && this.props.location && this.props.location.pathname){
      let pathname = this.props.location.pathname
      menuList.some((a,i)=>{
        if(a.url == pathname){
          selectKey = a.url
          return true
        }
      })
    }
    let {winWidth} = this.state
    let showMoreMenu = true
    return (
      <Menu mode='vertical'
      style={{height: 420}}
      defaultSelectedKeys={[selectKey]}
      selectedKeys={[selectKey]}
      onClickMenuItem={(skey)=>{
        this.setState({showModal: false})
        if(skey == 'search'){
          return
        }else if(skey == 'more'){
          return
        }else if(skey.includes('menu')){
          let language = 'ch'
          if(skey == 'menu_1'){
            language = 'ch'
          }else if(skey == 'menu_2'){
            language = 'en'
          }else if(skey == 'menu_3'){
            language = 'de'
          }
          console.log(language)
          this.props.onSetLanguage(language)
          return
        }
        this.props.history.push({
          pathname:skey,
          state: []
        })
      }}
    >
      {
        menuList.map((a,i)=>{
          let key = a.url
          return showMoreMenu && this.getMenuButton(a)
          return (
            <MenuItem key={key}>{a.title}</MenuItem>
          )
        })
      }
      {showMoreMenu && this.getEnButton()}
      {/* {showMoreMenu && this.getSearchButton()} */}
    </Menu>
    )
  }

  getModalPanel(){
    let {showModal} = this.state
    let logoWidth = this.getLogoWidth()

    return (<Modal
      alignCenter={false}
      style={{width: 'calc(100vw - 5px)', height: 450, top: 0, left: 0}}
      title=''
      visible={showModal}
      onOk={() => this.setState({showModal: false})}
      onCancel={() => this.setState({showModal: false})}
      autoFocus={false}
      focusLock={true}
      footer={null}
      // closeIcon= {null}
    >
      <div style={{display: 'flex', justifyContent: 'right',backgroundColor: 'red', alignItems: 'center', width: `calc(100vw - ${logoWidth}px)`, textAlign: 'left'}}>

        {this.getModalMenu()}
      </div>
    </Modal>)
  }
  getTopNav(){
    let {language} = this.props
    console.log(language)

    let menuList = utils.GetMenuList(language)
    let selectKey = ''
    if(this.props && this.props.location && this.props.location.pathname){
      let pathname = this.props.location.pathname
      menuList.some((a,i)=>{
        if(a.url == pathname){
          selectKey = a.url
          return true
        }
      })
    }
    let {winWidth} = this.state
    let logoWidth = this.getLogoWidth()
    let showMoreMenu = winWidth > 560 + logoWidth + 30
    if(!showMoreMenu){
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 50 }}>
          {this.getHeadImg()}
          <div style={{position: 'absolute', justifyContent: 'right', alignItems: 'center', right: 30, textAlign: 'right'}}>
            {this.getMoreShortButton()}
          </div>
        </div>
      )
    }
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '84.5vw', height: 58}}>
          {this.getHeadImg()}
          <div style={{display: 'flex', justifyContent: 'right', alignItems: 'center', width: `calc(84.5vw - ${logoWidth}px)`, textAlign: 'right'}}>
          <Menu mode='horizontal'
            style={{width: `calc(84.5vw - ${logoWidth}px)`}}
            defaultSelectedKeys={[selectKey]}
            selectedKeys={[selectKey]}
            onClickMenuItem={(skey)=>{
              if(skey == 'search'){
                return
              }else if(skey == 'more'){
                return
              }else if(skey.includes('menu')){
                let language = 'ch'
                if(skey == 'menu_1'){
                  language = 'ch'
                }else if(skey == 'menu_2'){
                  language = 'en'
                }else if(skey == 'menu_3'){
                  language = 'de'
                }
                console.log(language)
                this.props.onSetLanguage(language)
                return
              }
              this.props.history.push({
                pathname:skey,
                state: []
              })
            }}
          >
            {
              menuList.map((a,i)=>{
                let key = a.url
                return showMoreMenu && this.getMenuButton(a)
                return (
                  <MenuItem key={key}>{a.title}</MenuItem>
                )
              })
            }
            {showMoreMenu && this.getEnButton()}
            {/* {showMoreMenu && this.getSearchButton()} */}
            {showMoreMenu && this.getMoreButton()}
          </Menu>
          </div>
        </div>
      </div>
    )
  }
  render() {
    return (<div style={{width: '100%'}}>
      {this.getTopNav()}
      {this.getModalPanel()}
    </div>)
  }
}
export default withRouter(NAVBAR);

